(() => {
  const SELECTOR = '[data-mm-volume-discount]';

  function setActive(container, qty) {
    if (!container) return;
    const n = Number(qty) || 1;
    container.querySelectorAll('[data-mm-volume-min]').forEach((button) => {
      const min = Number(button.dataset.mmVolumeMin || 0);
      const max = Number(button.dataset.mmVolumeMax || 999999);
      button.classList.toggle('is-active', n >= min && n <= max);
      button.setAttribute('aria-pressed', n >= min && n <= max ? 'true' : 'false');
    });
  }

  function setStatus(container, message) {
    const status = container && container.querySelector('[data-mm-volume-status]');
    if (status && message) status.textContent = message;
  }

  function initCurrentStates(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach((container) => {
      if (container.dataset.mmVolumeContext === 'cart') {
        setActive(container, Number(container.dataset.mmCurrentCount || 0));
      } else {
        const form = container.closest('form[data-type="add-to-cart-form"]');
        const input = form && form.querySelector('input[name="quantity"]');
        setActive(container, input ? Number(input.value || 1) : 1);
      }
    });
  }

  async function handleProductTier(button, container) {
    const target = Number(button.dataset.mmVolumeQty || 1);
    const form = container.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const qtyInput = form.querySelector('input[name="quantity"]');
    const addButton = form.querySelector('button[name="add"]');
    if (!qtyInput || !addButton || addButton.disabled || addButton.classList.contains('disabled')) return;

    let quantity = target;
    const max = Number(qtyInput.getAttribute('max'));
    if (Number.isFinite(max) && max > 0 && quantity > max) {
      setStatus(container, `Only ${max} available for this option.`);
      return;
    }

    qtyInput.value = quantity;
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    setActive(container, quantity);

    button.classList.add('is-loading');
    setStatus(container, `Adding ${quantity} item${quantity === 1 ? '' : 's'} to your cart…`);

    // Use the theme's own product-form submit flow so cart drawer/count/notifications still work.
    addButton.click();

    window.setTimeout(() => {
      button.classList.remove('is-loading');
      setStatus(container, `${quantity} item${quantity === 1 ? '' : 's'} selected. Your automatic discount will apply when eligible.`);
    }, 1400);
  }

  function handleCartTier(button, container) {
    const target = Number(button.dataset.mmVolumeQty || 1);
    const currentCount = Number(container.dataset.mmCurrentCount || 0);
    const firstLineQty = Number(container.dataset.mmFirstLineQty || 0);

    if (target <= currentCount) {
      setStatus(container, `Your cart already has ${currentCount} items and qualifies for this level or better.`);
      setActive(container, currentCount);
      return;
    }

    const cart = container.closest('m-cart, m-cart-drawer-items') || document.getElementById('MinimogCart');
    if (!cart || typeof cart.updateQuantity !== 'function' || firstLineQty < 1) return;

    const extraNeeded = target - currentCount;
    const newFirstLineQty = firstLineQty + extraNeeded;
    button.classList.add('is-loading');
    setStatus(container, `Adding ${extraNeeded} more item${extraNeeded === 1 ? '' : 's'} to reach ${target}…`);
    cart.updateQuantity(1, newFirstLineQty, 'plus');
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mm-volume-qty]');
    if (!button || button.disabled) return;
    const container = button.closest(SELECTOR);
    if (!container) return;

    event.preventDefault();
    if (container.dataset.mmVolumeContext === 'cart') {
      handleCartTier(button, container);
    } else {
      handleProductTier(button, container);
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="quantity"]')) return;
    const form = event.target.closest('form[data-type="add-to-cart-form"]');
    const container = form && form.querySelector(SELECTOR);
    if (container) setActive(container, Number(event.target.value || 1));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCurrentStates());
  } else {
    initCurrentStates();
  }

})();
